module.exports = __webpack_public_path__ + "assets/img/hover_detail_fukidashi.e13eaa28.svg";